const getters = {
  getButtonActive: (state) => state.buttonActive,
  getShowDescFooter: (state) => state.showDescFooter,
  getFooterTemplate: (state) => state.footerTemplate,
  getHeaderIconLeft: (state) => state.headerIconLeft,
  getHeaderIconRight: (state) => state.headerIconRight,
  getSearchBar: (state) => state.searchBar,
  getSearchBarPlaceholder: (state) => state.searchBarPlaceholder,
  getSearchBarTriggered: (state) => state.searchBarTriggered,
  getSearchBarCondition: (state) => state.searchBarCondition,
  getMobileBodyHeight: (state) => state.mobileBodyHeight,
  getBackLink: (state) => state.backLink,
};

export default getters;
